export enum HomeSectionType {
    LiveCourses,
    RecordedCourses,
    LearningPaths,
    MiddleBanner,
    Partners,
    Testimonials,
    TrainingCenters,
    Features,
    Statistics,
    OnsiteCourses,
    CompactCourses,
    Instructors,
    Advertisements
}
